import React from 'react';
import { JobRequisitionViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: JobRequisitionViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
